import { CloseIcon } from "@saas-ui/core";
import { ClearIndicatorProps, GroupBase } from "react-select";

export const ClearIndicator = <
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
>({
  innerProps,
}: ClearIndicatorProps<Option, IsMulti, Group>) => {
  return (
    <div {...innerProps}>
      <CloseIcon className="mr-2 cursor-pointer" data-cy="close-indicator" />
    </div>
  );
};
